import * as React from 'react';
import SelectField from 'material-ui/SelectField';

const zoom = {zoom: 1.2}
const renderSelectField = ({ input, label, meta: { touched, error }, children, style={}, ...custom}) => {
  return <SelectField
  floatingLabelText={label}
  errorText={touched && error}
  {...input}
  onChange={(event, index, value) => input.onChange(value)}
	children={children}
	style={{...style, ...zoom}}
	//listStyle={zoom}
    {...custom}
    />
};

export default renderSelectField;



// WEBPACK FOOTER //
// ./src/app/components/fields/SelectField.tsx